<template>
  <div class="join-us">
    <section class="g-bg-gray-light-v5">
      <div class="container g-py-50">
        <div class="text-center">
          <div class="align-self-center">
            <h2 class="h3 g-font-weight-300 w-100 g-mb-10 g-mb-0--md">加入成為【智郵易】夥伴</h2>
            <span>請在下方填上資料，【智郵易】會盡快與您聯絡您。</span>
          </div>
        </div>
      </div>
    </section>
    <section class="container g-py-100">
      <el-form ref="form" :model="form" :rules="formRules" label-width="7rem">
        <el-form-item prop="business" label="公司業務">
          <el-input v-model="form.business" placeholder="請輸入您的公司的業務範圍" />
        </el-form-item>
        <el-form-item prop="company_name" label="公司名稱">
          <el-input v-model="form.company_name" placeholder="請輸入您公司的名稱" />
        </el-form-item>
        <el-form-item prop="franchise_store_address" label="加盟點地址">
          <el-input v-model="form.franchise_store_address" placeholder="請輸入您公司所在地址" />
        </el-form-item>
        <el-form-item prop="name" label="聯繫人姓名">
          <el-input v-model="form.name" />
        </el-form-item>
        <el-form-item prop="phone" label="聯繫人電話">
          <el-input v-model="form.phone" />
        </el-form-item>
        <el-form-item prop="email" label="聯繫人電郵">
          <el-input v-model="form.email" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submit">提交</el-button>
        </el-form-item>
      </el-form>
    </section>
  </div>
</template>

<script>
import { showErrorMessage, getLoadingInstance } from '../helpers';

export default {
  name: 'JoinUs',
  data() {
    return {
      form: {
        business: '',
        company_name: '',
        franchise_store_address: '',
        name: '',
        phone: '',
        email: '',
      },
      formRules: {
        business: { required: true, message: '請輸入您的公司的業務範圍', trigger: 'blur' },
        company_name: { required: true, message: '請輸入您公司的名稱', trigger: 'blur' },
        franchise_store_address: { required: true, message: '請輸入您公司所在地址', trigger: 'blur' },
        name: { required: true, message: '請輸入聯繫人姓名', trigger: 'blur' },
        phone: { required: true, message: '請輸入聯繫人電話', trigger: 'blur' },
        email: [
          { required: true, message: '請輸入聯繫人郵箱', trigger: 'blur' },
          { type: 'email', message: '郵箱格式錯誤', trigger: 'blur' },
        ],
      },
    };
  },
  methods: {
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const loading = getLoadingInstance();
          this.$api.app.joinRequest(this.form).then(() => {
            this.$notify.success({
              title: '已經提交您的申請，【智郵易】會盡快與您聯絡您。',
            });
            this.form = {
              business: '',
              company_name: '',
              franchise_store_address: '',
              name: '',
              phone: '',
              email: '',
            };
          }).catch((e) => {
            showErrorMessage(e);
          }).finally(() => {
            loading.close();
          });
        }
      });
    },
  },
};
</script>
